   document.body.addEventListener('click', function(event) {
   	var detailsElement = event.target.closest('details');
   	if (detailsElement) {
   		if (detailsElement.hasAttribute('data-attr')) {
   			var megaMenu = detailsElement.getAttribute('data-attr');


   			// const megaMenuImages = document.querySelectorAll('li.mega-menu-image');
   			// megaMenuImages.forEach(function(item) {
   			// 	item.style.display = 'none';
   			// });
   			//var megaMenuItems = document.querySelectorAll(`li.mega-menu-image[data-menu="${megaMenu}"]`);
   			megaMenuItems.forEach(function(item) {
   				item.style.display = 'grid';
   			});
   		} else {

   		}
   	} else {

   	}
   });



   document.body.addEventListener("mouseenter", function(event) {
   	let menuElement = event.target.closest("header-menu details");

   	if (menuElement) {

   		document.querySelectorAll("header-menu details").forEach(detail => {
   			detail.removeAttribute("open");
   			detail.classList.remove("mega-menu-open");
   			setTimeout(function() {
   				$(detail).find('.mega-menu__content,ul.mega-menu__list li').css({
   					'opacity': '0',
   					'transform': 'translateY(10px)',
   					'transition': 'all ease-in-out .5s'
   				});

   			}, 300);
   		});


   		document.querySelectorAll("header-menu summary").forEach(summary => {
   			summary.setAttribute("aria-expanded", "false");
   		});


   		// document.querySelectorAll("li.mega-menu-image").forEach(image => {
   		// 	image.style.display = "none";
   		// });


   		let menuHandle = menuElement.getAttribute("data-attr");

   		menuElement.setAttribute("open", "open");
   		menuElement.classList.add("mega-menu-open");
   		// document.querySelectorAll(`li.mega-menu-image[data-menu="${menuHandle}"]`).forEach(image => {
   		// 	image.style.display = "block";
   		// });
   		setTimeout(function() {
   			$(menuElement).find('.mega-menu__content,ul.mega-menu__list li').css({
   				'opacity': '1',
   				'transform': 'translateY(0px)',
   				'transition': 'all ease-in-out .5s'
   			});


   		}, 300);
   		let summaryElement = menuElement.querySelector("summary");
   		if (summaryElement) {
   			summaryElement.setAttribute("aria-expanded", "true");
   		}
   		
   	}
   }, true);



   function handleMegaMenuReset() {
   	document.querySelectorAll('header-menu details').forEach(detail => {
   		detail.removeAttribute('open');
   		detail.classList.remove('mega-menu-open');

   		setTimeout(function() {
   			$(detail).find('.mega-menu__content, ul.mega-menu__list li').css({
   				'opacity': '0',
   				'transform': 'translateY(10px)',
   				'transition': 'all ease-in-out .5s'
   			});
   		}, 300);
   	});

   	document.querySelectorAll('header-menu summary').forEach(summary => {
   		summary.setAttribute('aria-expanded', 'false');
   	});

   	// document.querySelectorAll('li.mega-menu-image').forEach(image => {
   	// 	image.style.display = 'none';
   	// });
   	

   }

   // Attach to both mouseenter and click
   document.querySelectorAll('li.mega-menu-without-childmenu').forEach(item => {
   	item.addEventListener('mouseenter', handleMegaMenuReset);
   	item.addEventListener('click', handleMegaMenuReset);
   });


   document.querySelector('header').addEventListener('mouseleave', function() {
   	document.querySelectorAll('header-menu details').forEach(detail => {
   		detail.removeAttribute('open');
   		detail.classList.remove('mega-menu-open');

   		setTimeout(function() {
   			$(detail).find('.mega-menu__content,ul.mega-menu__list li').css({
   				'opacity': '0',
   				'transform': 'translateY(10px)',
   				'transition': 'all ease-in-out .5s'
   			});
   		}, 300);
   	});

   	document.querySelectorAll('header-menu summary').forEach(summary => {
   		summary.setAttribute('aria-expanded', 'false');
   	});

   	// document.querySelectorAll('li.mega-menu-image').forEach(image => {
   	// 	image.style.display = 'none';
   	// });
   });




   $('body').on('mouseenter', '.Simple_dropdown-main-item.mega-menu-open ul.mega-menu__list > li', function() {
   	$('.Simple_dropdown-dropdown-menu').stop(true, true).fadeOut(200);
   	$(this).children('.Simple_dropdown-dropdown-menu').stop(true, true).fadeIn(300);
   	
   });


   $('body').on('mouseenter', '.Simple_dropdown-dropdown-menu', function() {
   	$(this).stop(true, true).fadeIn(300);
   	
   });


//    $('body').on('mouseleave', '.Simple_dropdown-main-item.mega-menu-open ul.mega-menu__list > li, .Simple_dropdown-dropdown-menu', function() {
//    	let $submenu = $(this).children('.Simple_dropdown-dropdown-menu');

//    	setTimeout(() => {
//    		if (!$submenu.is(':hover') && !$(this).is(':hover')) {
//    			$submenu.stop(true, true).fadeOut(200);
//    		}
//    	}, 100);
//    });

   $('body').on('mouseenter', 'a.mega-menu__link.mega-menu__link--level-2', function () {
  var getImagemenu = $(this).attr('data-menu');
console.log(getImagemenu)
  // Hide all mega menu images first
 $('li.mega-menu-image').css({
  opacity: '0',
  transform: 'translateY(10px)',
  display: 'none'
});

  // Find matching image inside the corresponding dropdown menu
  $(this)
    .siblings('ul.list-unstyled.Simple_dropdown-dropdown-menu')
    .find(`li.mega-menu-image[data-menu='${getImagemenu}']`)
    .show();
});
